export default "__VITE_PUBLIC_ASSET__cd2d7bcb__"